import { formatDate } from "../../helper/common";

/**
 * Used to filter notification tasks for the created on date
 * @param {*} tasks
 * @author Prachi Jain
 * @returns {Array} filtered task that have Notification Date
 */
export const formatNotificationTasks = (tasks) => {
  const filteredTasks = [];
  tasks?.map((task) => {
    task.Date = task.CreatedOn ? formatDate(task.CreatedOn) : "";
    filteredTasks.push(task);
  });
  return filteredTasks;
};

export const notificationInitialGroup = [
  {
    field: "Date",
  },
];

/**
 * retuns notification message for EntityType Tasks for notifications
 * @param { Object } notification
 * @returns {JSX}
 */
export const getNotificationMessage = (notification) => {
  let { EntityType, NotificationMessage, ProjectTaskID, Name } = notification;

  if (EntityType == "TaskApproval") {
    return NotificationMessage.replace(ProjectTaskID, `<span class='task-name-color'>${ProjectTaskID}</span>`);
  }
  if (EntityType !== "Tasks") return NotificationMessage?.replace(Name, `<span class='task-name-color w-100'>${Name}</span>`);

  if (!NotificationMessage.includes(notification?.ProjectTaskID)) return NotificationMessage?.replace(Name, `<span class='task-name-color'>${Name}</span>`);

  return NotificationMessage.replace(ProjectTaskID, `<span class='task-name-color'>${Name}</span>`);
};
